import React from 'react';
import PropTypes from 'prop-types';
import {
  commentsProps,
  entitiesWithKudosAndComments,
  viewingAthleteProps
} from '../../../components/Feed/props/feed-prop-types';
import Microfrontend, { getMfeRemoteEntryUrl } from '../../Microfrontend';

const ADPKudosAndComments = ({
  canKudo,
  commentsEnabled,
  comments,
  kudosCount,
  entity,
  entityId,
  ownerName,
  ownerAvatarUrl,
  ownerAthleteId,
  activityName,
  ownedByCurrentAthlete,
  viewingAthlete
}) => {
  const appContext = {
    canKudo,
    commentsEnabled,
    comments,
    kudosCount,
    entity,
    entityId,
    ownerName,
    ownerAvatarUrl,
    ownerAthleteId,
    activityName,
    ownedByCurrentAthlete,
    viewingAthlete
  };

  return (
    <Microfrontend
      url={getMfeRemoteEntryUrl('adp-social-engagement')}
      scope="strava_adp_social_engagement"
      component="./App"
      appContext={appContext}
    />
  );
};

ADPKudosAndComments.propTypes = {
  canKudo: PropTypes.bool.isRequired,
  comments: commentsProps.isRequired,
  kudosCount: PropTypes.number.isRequired,
  entityId: PropTypes.string.isRequired,
  ownerName: PropTypes.string.isRequired,
  ownerAvatarUrl: PropTypes.string.isRequired,
  ownedByCurrentAthlete: PropTypes.bool.isRequired,
  ownerAthleteId: PropTypes.number.isRequired,
  activityName: PropTypes.string.isRequired,
  commentsEnabled: PropTypes.bool.isRequired,
  entity: entitiesWithKudosAndComments.isRequired,
  viewingAthlete: viewingAthleteProps.isRequired
};

export default ADPKudosAndComments;
